// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Admin__ActionController from "./admin/action_controller"
application.register("admin--action", Admin__ActionController)

import Admin__ColorPickerController from "./admin/color_picker_controller"
application.register("admin--color-picker", Admin__ColorPickerController)

import Admin__ContentStatusController from "./admin/content_status_controller"
application.register("admin--content-status", Admin__ContentStatusController)

import Admin__ImageAttachmentController from "./admin/image_attachment_controller"
application.register("admin--image-attachment", Admin__ImageAttachmentController)

import Admin__MultiSelectController from "./admin/multi_select_controller"
application.register("admin--multi-select", Admin__MultiSelectController)

import Admin__SortableController from "./admin/sortable_controller"
application.register("admin--sortable", Admin__SortableController)

import Home__JournalController from "./home/journal_controller"
application.register("home--journal", Home__JournalController)

import Home__SliderController from "./home/slider_controller"
application.register("home--slider", Home__SliderController)

import Home__VideoController from "./home/video_controller"
application.register("home--video", Home__VideoController)

import Home__WorkStreamsAltController from "./home/work_streams_alt_controller"
application.register("home--work-streams-alt", Home__WorkStreamsAltController)

import Home__WorkStreamsController from "./home/work_streams_controller"
application.register("home--work-streams", Home__WorkStreamsController)

import MarqueeController from "./marquee_controller"
application.register("marquee", MarqueeController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import MorphController from "./morph_controller"
application.register("morph", MorphController)

import NewsletterController from "./newsletter_controller"
application.register("newsletter", NewsletterController)

import RelatedContentController from "./related_content_controller"
application.register("related-content", RelatedContentController)

import ServicesController from "./services_controller"
application.register("services", ServicesController)

import SliderController from "./slider_controller"
application.register("slider", SliderController)
